export const UserInfo = state => state.login.token
export const LoginStatus = state => state.loginstatus
export const PickingData = state => state.PickingData



// WEBPACK FOOTER //
// ./src/store/getters.js